export const progressMagicJwtToken = 'progressMagicJwtToken';

export const authTokenSilentRefreshCycleTime = 30 * 60 * 1000; // 30 minutes

export const videoDontShowAgainKey = 'videoDontShowAgainKey';

export const speechToTextSilenceTime = process.env.REACT_APP_SPEECH_SILENCE_TIMEOUT; // 10 seconds

export default progressMagicJwtToken;

export const twkToken1 = 'twk_6597c2b88d261e1b5f4fe8b6';

export const twkToken2 = 'twk_token_6597c2b88d261e1b5f4fe8b6';

export const brandTagKey = 'brandTag';

export const brandNameLogoKey = 'brandNameLogo';

export const brandLogoKey = 'brandLogo';
